import React from "react";
import { Card, Row, Col, Typography, Statistic } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
import HeadingSubHeading from "../../../components/ViewHeading/HeadingSubHeading";
import Box from "../../../components/Box/Box";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Legend, Bar, Cell, Tooltip } from "recharts";
const { Title, Text } = Typography;

const LeaveSummary = () => {
    const leaveData = [
        {
            title: "Employees on Leave",
            value: "6.38%",
            description: "%age of employees that were on leave during the selected duration.",
            progress: "10.64%",
            icon: <ArrowUpOutlined style={{ color: "green" }} />,
        },
        {
            title: "Avg. Leave Taken",
            value: "3 days",
            description: "Avg. leave taken by an employee during the selected duration.",
            progress: "100%",
            icon: <ArrowUpOutlined style={{ color: "green" }} />,
        },
        {
            title: "Total Leave Balance",
            value: "609.39",
            description: "Balance available with employees irrespective of selected date range.",
            progress: "0%",
            icon: <ArrowUpOutlined style={{ color: "green" }} />,
        },
        {
            title: "Unplanned Leave Taken",
            value: "0",
            description: "Total leave applied for after the leave has been consumed taken.",
            progress: "100%",
            icon: <ArrowUpOutlined style={{ color: "green" }} />,
        },
    ];

    const arrivalData = [
        { date: "Nov 1", leave: 5 },
        { date: "Nov 2", leave: 7 },
        { date: "Nov 3", leave: 8 },
        { date: "Nov 4", leave: 5 },
        { date: "Nov 5", leave: 6 },
        { date: "Nov 6", leave: 7 },
        { date: "Nov 7", leave: 8 },
        { date: "Nov 8", leave: 5 },
        { date: "Nov 9", leave: 6 },
        { date: "Nov 10", leave: 7 },
        { date: "Nov 11", leave: 8 },
        { date: "Nov 12", leave: 5 },
        { date: "Nov 13", leave: 6 },
        { date: "Nov 14", leave: 7 },
        { date: "Nov 15", leave: 8 },
        { date: "Nov 16", leave: 5 },
        { date: "Nov 17", leave: 6 },
        { date: "Nov 18", leave: 7 },
        { date: "Nov 19", leave: 8 },
        { date: "Nov 20", leave: 5 },
        { date: "Nov 21", leave: 6 },
    ]

    const colors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', 'red', 'pink'];

    const randomColor = () => {
        return colors[Math.floor(Math.random() * colors.length)];
    }

    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <HeadingSubHeading titleProps={{ level: 5 }} title="Leave for Past Dates" />
            </Col>
            <Col span={24}>
                <Row gutter={[16, 16]} justify="space-between">
                    {leaveData.map((item, index) => (
                        <Col key={index} xs={24} sm={12} md={6}>
                            <Card
                                bordered={false}
                                style={{
                                    borderRadius: "8px",
                                    background: index === 0 ? "#d9d6f6" : "#fff", // Highlight first card
                                }}
                            >
                                <Statistic
                                    title={
                                        <>
                                            <Text strong>{item.title}</Text>
                                            <span style={{ float: "right", color: "green" }}>{item.icon}</span>
                                        </>
                                    }
                                    value={item.value}
                                />
                                <Text type="secondary" style={{ fontSize: "12px" }}>
                                    {item.description}
                                </Text>
                                <div style={{ marginTop: "8px", fontSize: "12px", color: "green" }}>
                                    <ArrowUpOutlined /> {item.progress}
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Col>
            <Col span={24}>
                <Box>
                    <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                            width={500}
                            height={300}
                            data={arrivalData}
                            margin={{
                                top: 20,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Bar dataKey="leave" width={10} name="Leave for Past Dates" fill="#8884d8" label={{ position: 'top' }}>
                                {arrivalData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={randomColor()} />
                                ))}
                            </Bar>
                            <Legend />
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            </Col>
        </Row >
    );
}

export default LeaveSummary;